<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs v3-portlet {{
		sectionclass
	}} sem-conversions"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="cards-holder devices-tab">
		<div class="card card2 mRight devices-card">
			<div
				class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
			>
				<div class="o-stack__cell">
					<h5 class="card-title">{{ sectiontitle }}</h5>
					<span class="datatable-icon" *ngIf="hasData">
						<a
							href="javascript:void(0)"
							class="datatable_download_icon"
							(click)="downloadCSVData($event)"
							target="_blank"
							*ngIf="devicedatatableconfig && devicedatatableconfig.enableDownload"
						>
							<i class="fa fa-download" aria-hidden="true"></i>
						</a>
					</span>
				</div>
			</div>
		</div>
		<div id="pie-donut-graph-container" *ngIf="hasData">
			<div class="metrics-header">
				<div class="sem-conversion-metrics" *ngFor="let metric of metricObject">
					<div class="conversion-metrics" appTooltip [attr.title]="metric?.tooltip" [options]="tooltipOptions">
						<div class="metric-value">
							{{ metric.value }}
						</div>
						<div class="metric-name">
							{{ metric.name }}
						</div>
					</div>
				</div>
			</div>
			<app-generic-chart
				[colorPalette]="colorPalette"
				[configuration]="widgetsConfiguration"
				[data]="donutPartData"
			></app-generic-chart>
		</div>
		<div class="no-data-container no-container" *ngIf="!hasData">
			<div class="map-no-data">No Data to Display</div>
		</div>
	</div>
</div>
